import { SubscriptionLevelEnum } from "@fena/toolkit-types";
import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useShowBlockingOverlay = (
  hasPaymentsOnlySubscription: boolean,
  canManageCompanies?: boolean,
  hasB2BSubscription?: boolean,
  hasToolkitSubscription?: boolean,
  b2bSubscriptionLevel?: SubscriptionLevelEnum
) => {
  const location = useLocation();
  const showBlockingOverlay = useMemo(() => {
    if (
      !hasB2BSubscription &&
      !hasToolkitSubscription &&
      !hasPaymentsOnlySubscription
    ) {
      if (location.pathname.includes("private/inventory")) {
        return true;
      } else if (location.pathname.includes("order-generation")) {
        return true;
      } else if (location.pathname.includes("payments")) {
        return true;
      } else if (location.pathname.includes("invoices")) {
        return true;
      } else if (location.pathname.includes("quotes")) {
        return true;
      } else if (location.pathname.includes("shipments")) {
        return true;
      } else if (location.pathname.includes("team")) {
        return true;
      } else if (location.pathname.includes("bank-accounts")) {
        if (canManageCompanies) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("roles")) {
        return true;
      } else if (location.pathname.includes("api-keys")) {
        if (canManageCompanies) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("delivery")) {
        return true;
      } else if (location.pathname.includes("segments")) {
        return true;
      } else if (location.pathname.includes("integrations")) {
        return true;
      } else if (location.pathname.includes("settings/apps")) {
        return true;
      } else if (location.pathname.includes("customisation")) {
        return true;
      } else if (location.pathname.includes("locations")) {
        return true;
      } else if (location.pathname.includes("reminders")) {
        return true;
      } else if (location.pathname.includes("currency")) {
        return true;
      } else if (location.pathname.includes("terminal-management")) {
        return true;
      } else if (location.pathname.includes("sync-management")) {
        return true;
      } else {
        return false;
      }
    } else if (hasPaymentsOnlySubscription) {
      if (location.pathname.includes("private/inventory/orders")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      }
      if (location.pathname.includes("private/reports/card-payments")) {
        if (hasB2BSubscription) {
          return true;
        } else {
          return true;
        }
      } else if (location.pathname.includes("private/inventory/products")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("private/inventory/stock")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("private/inventory/categories")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("private/inventory/brands")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("private/inventory/incoming")) {
        return true;
      } else if (
        location.pathname.includes("private/inventory/rejected-and-missing")
      ) {
        return true;
      } else if (location.pathname.includes("private/inventory/customers")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("private/inventory/suppliers")) {
        return true;
      } else if (location.pathname.includes("order-generation")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("payments")) {
        return false;
      } else if (location.pathname.includes("private/commercial-invoices")) {
        if (hasB2BSubscription) {
          return true;
        } else {
          return true;
        }
      } else if (location.pathname.includes("quotes")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("shipments")) {
        return true;
      } else if (location.pathname.includes("api-keys")) {
        return false;
      } else if (location.pathname.includes("delivery")) {
        return true;
      } else if (location.pathname.includes("segments")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (
        location.pathname.includes("customisation/email-notification")
      ) {
        return false;
      } else if (location.pathname.includes("customisation/payment-page")) {
        return false;
      } else if (location.pathname.includes("customisation/invoice-design")) {
        return false;
      } else if (
        location.pathname.includes("customisation/fena-checkout-flow")
      ) {
        return false;
      } else if (location.pathname.includes("integrations/accounting")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return false;
        }
      } else if (
        location.pathname.includes("integrations/warehouse-management")
      ) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("integrations/other-apps")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("integrations/e-commerce")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("integrations/marketplaces")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("apps")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("integrations/carriers")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("locations")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("reminders")) {
        if (hasB2BSubscription) {
          return false;
        } else {
          return true;
        }
      } else if (location.pathname.includes("sync-management")) {
        return true;
      } else {
        return false;
      }
    } else if (hasB2BSubscription && !hasToolkitSubscription) {
      if (location.pathname.includes("reports")) {
        return true;
      } else if (location.pathname.includes("suppliers")) {
        return true;
      } else if (location.pathname.includes("shipments")) {
        return true;
      } else if (location.pathname.includes("commercial-invoices")) {
        return true;
      } else if (location.pathname.includes("/private/payments")) {
        return true;
      } else if (location.pathname.includes("transactions")) {
        return true;
      } else if (location.pathname.includes("rejected-and-missing")) {
        return true;
      } else if (location.pathname.includes("inventory/incoming")) {
        return true;
      } else if (location.pathname.includes("terminal-management")) {
        return true;
      } else if (location.pathname.includes("private/order-generation")) {
        if (
          b2bSubscriptionLevel === SubscriptionLevelEnum.STARTER ||
          b2bSubscriptionLevel === SubscriptionLevelEnum.SCALE_UP
        ) {
          return true;
        } else {
          return false;
        }
      } else if (location.pathname.includes("private/invoices")) {
        if (
          b2bSubscriptionLevel === SubscriptionLevelEnum.STARTER ||
          b2bSubscriptionLevel === SubscriptionLevelEnum.SCALE_UP
        ) {
          return true;
        } else {
          return false;
        }
      } else if (location.pathname.includes("private/quotes")) {
        if (
          b2bSubscriptionLevel === SubscriptionLevelEnum.STARTER ||
          b2bSubscriptionLevel === SubscriptionLevelEnum.SCALE_UP
        ) {
          return true;
        } else {
          return false;
        }
      } else if (location.pathname.includes("private/settings/segments")) {
        if (b2bSubscriptionLevel === SubscriptionLevelEnum.STARTER) {
          return true;
        } else {
          return false;
        }
      }
    }
  }, [
    hasPaymentsOnlySubscription,
    canManageCompanies,
    hasB2BSubscription,
    hasToolkitSubscription,
    b2bSubscriptionLevel,
    location.pathname,
  ]);

  const restrictedPaths = useMemo(() => {
    if (
      !hasB2BSubscription &&
      !hasToolkitSubscription &&
      !hasPaymentsOnlySubscription
    ) {
      return [
        "private/inventory",
        "order-generation",
        "payments",
        "invoices",
        "quotes",
        "shipments",
        "team",
        "bank-accounts",
        "roles",
        "api-keys",
        "delivery",
        "segments",
        "integrations",
        "settings/apps",
        "customisation",
        "locations",
        "reminders",
        "currency",
        "terminal-management",
        "sync-management",
      ];
    }

    if (hasPaymentsOnlySubscription) {
      return hasB2BSubscription
        ? [
            "private/inventory/suppliers",
            "private/commercial-invoices",
            "private/reports/card-payments",
            "shipments",
          ]
        : [
            "private/reports/card-payments",
            "private/inventory/orders",
            "private/inventory/products",
            "private/inventory/stock",
            "private/inventory/categories",
            "private/inventory/brands",
            "private/inventory/incoming",
            "private/inventory/rejected-and-missing",
            "private/inventory/customers",
            "private/inventory/suppliers",
            "order-generation",
            "private/commercial-invoices",
            "quotes",
            "shipments",
            "api-keys",
            "delivery",
          ];
    }

    if (hasB2BSubscription && !hasToolkitSubscription) {
      if (
        b2bSubscriptionLevel === SubscriptionLevelEnum.SCALE_UP ||
        b2bSubscriptionLevel === SubscriptionLevelEnum.STARTER
      ) {
        return [
          "/private/order-generation",
          "/private/invoices",
          "/private/quotes",

          "reports",
          "suppliers",
          "shipments",
          "commercial-invoices",
          "/private/payments",
          "transactions",
          "rejected-and-missing",
          "inventory/incoming",
          "terminal-management",
        ];
      } else {
        return [
          "reports",
          "suppliers",
          "shipments",
          "commercial-invoices",
          "/private/payments",
          "transactions",
          "rejected-and-missing",
          "inventory/incoming",
          "terminal-management",
        ];
      }
    }

    return [];
  }, [
    hasB2BSubscription,
    hasToolkitSubscription,
    hasPaymentsOnlySubscription,
    b2bSubscriptionLevel,
  ]);

  const showLockIcon = useCallback(
    (tabRoute?: string) => {
      return restrictedPaths.some((path) => tabRoute?.includes(path));
    },
    [restrictedPaths]
  );

  return {
    showBlockingOverlay,
    showLockIcon,
  };
};
